var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-button",class:[_vm.type, { disabled: _vm.disabled }, { active: _vm.active }],on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }